import Pop from 'components/Popover/Pop';
import Text from 'components/Text/Text';
import { useLoggedUserRestaurants } from 'hooks/useLoggedUserRestaurants';
import React from 'react';
import style from './RestaurantsList.module.scss';

interface IRestaurantsListRestaurant {
	id: string;
	restaurantName: string | null;
}

interface IProps {
	restaurants: IRestaurantsListRestaurant[];
}

const RestaurantsList: React.FC<IProps> = ({ restaurants }) => {
	const accessibleRestaurants = useLoggedUserRestaurants(restaurants);

	const RestaurantsContent = () => {
		return (
			<div className={style.container} data-test="RestaurantsContent">
				{accessibleRestaurants.map((el) => (
					<div className={style.item} key={el.id}>
						<Text translationKey={el.restaurantName} size="xs" />
					</div>
				))}
			</div>
		);
	};

	return (
		<div data-test="RestaurantsList">
			{accessibleRestaurants.length > 1 ? (
				<Pop placement="bottomLeft" content={<RestaurantsContent />} trigger="click">
					<div className={style.wrapper} data-test="Restaurant">
						<Text translationKey={accessibleRestaurants[0].restaurantName} withTooltip={true} />
						<span className={style.showListBtn}>&middot;&middot;&middot;</span>
					</div>
				</Pop>
			) : (
				<Text
					translationKey={accessibleRestaurants.length ? accessibleRestaurants[0].restaurantName : '-'}
					withTooltip={true}
				/>
			)}
		</div>
	);
};

export default React.memo(RestaurantsList);
